import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gkv-gpv-detailansicht"
export default class extends Controller {
	static targets = ["monat"]

	selectMonat(event) {
		this.monatTargets.forEach((monat) => monat.removeAttribute("data-ui"))
		event.currentTarget.dataset.ui = "aktiv"
	}
}
